module.exports = __webpack_public_path__ + "static/media/m_beard_long_diamond__v.a548f7c3.png";